import { connect } from "react-redux";

import { setPageMode, selectPageMode } from "~/store/ducks/application/page";
import { showModal } from "~/store/ducks/domain/ui/modal";

import {
  switchEditMode,
  selectEditMode
} from "~/store/ducks/application/annotations";

import {
  selectMenu,
  selectShowPageModeButton,
  selectShowFullScreenButton
} from "~/store/ducks/domain/ui/menu";

import { selectUsersettings } from "~/store/ducks/user/uistate";

import {
  selectIsStudentActive,
  selectIsDlsActive
} from "~/store/ducks/user/uistate";

import {
  selectIsFullScreen,
  toggleFullScreen
} from "~/store/ducks/application/screen";

import { selectIsManualPageControl } from "~/store/selectors/page";

import PageControls from "./PageControls";

function mapStateToProps(state) {
  return {
    menu: selectMenu(state),
    editMode: selectEditMode(state),
    pageMode: selectPageMode(state),
    showFullScreenButton: selectShowFullScreenButton(state),
    isFullScreen: selectIsFullScreen(state),
    showPageModeButton: selectShowPageModeButton(state),
    isStudentMode: selectIsStudentActive(state),
    isDlsMode: selectIsDlsActive(state),
    isManualPageControl: selectIsManualPageControl(state),
    usersettings: selectUsersettings(state)
  };
}

const mapDispatchToProps = {
  setPageMode,
  showModal,
  switchEditMode,
  toggleFullScreen
};

export default connect(mapStateToProps, mapDispatchToProps)(PageControls);
